import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbDocumentos } from 'app/abstract/full-pages/documentos/documentos.abstract';
import { AppFilter } from 'app/models/app-filter.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DocumentosService extends AbDocumentos {

  constructor(http: HttpClient) {
    super(http);
  }


  public getAllDocumentos(filter: AppFilter): Observable<any> {
    return this.get(`documento/filter_documento/${filter.encode()}`);
  }

  public salvarDocumento(entity) {
    return this.save("documento/", entity);
  }

  public getDocumento(id) {
    return this.get("documento/dto/", id);
  }

  public deleteDocumento(id) {
    return this.delete("documento/", id);
  }

  public getCategoria(id) {
    return this.get("categoria_documento/dto/", id);
  }

  public salvarCategoria(entity) {
    return this.save("categoria_documento/", entity);
  }

  public salvarSubcategoria(entity) {
    return this.save("subcategoria_documento/", entity);
  }

  public deleteSubcategoria(id) {
    return this.delete("subcategoria_documento/", id);
  }

  public deleteCategoria(id) {
    return this.delete("categoria_documento/", id);
  }

  public getAllCategorias(): Observable<any> {
    return this.get('categoria_documento/all/');
  }

  public getAllCategoriasFilter(filter: AppFilter): Observable<any> {
    return this.get(`categoria_documento/filter/${filter.encode()}`);
  }

  public uploadAnexos(documentoId: number, arquivos): Observable<any> {
    return this.post(`documentoanexos/upload/${documentoId}`, arquivos);
  }

  public getUsoArmazenamento(): Observable<any> {
    return this.get('documento/uso_armazenamento/');
  }
}
